module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0083.jpg?v=de17f42a";